import { render } from "./BrandPartnersPage.vue?vue&type=template&id=7f2b2c1e"
import script from "./BrandPartnersPage.vue?vue&type=script&lang=js"
export * from "./BrandPartnersPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__